import React, { useState } from "react";
import "./navbar.css";
import Logo from "../../Assets/logo.png";
import { Link } from "react-router-dom";
import { LANGUAGES } from "../../helpers/Constants";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FlagPT } from "../../Assets/flag-pt.svg";
import { ReactComponent as FlagEN } from "../../Assets/flag-en.svg";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

const Navbar = () => {
  const { i18n, t } = useTranslation();
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  const onChangeLang = (event) => {
    const lang_code = event.target.value;
    i18n.changeLanguage(lang_code);
  };

  let navigate = useNavigate();
  const goHome = () => {
    navigate("/");
  };

  // Map language codes to their SVG components
  const flagMap = {
    pt: FlagPT,
    en: FlagEN,
    // Add more mappings here
  };

  return (
    <nav className="navbar">
      <div>
        <img src={Logo} className="logo" alt="logo" onClick={goHome} />
        <div className="menu-icon" onClick={handleShowNavbar}>
          <div className={`hamburger ${showNavbar ? "active" : ""}`}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
          </div>
        </div>
      </div>
      <div className="container-navbar">
        <div className={`nav-elements  ${showNavbar && "active"}`}>
          <ul>
            <li>
              <Link to="/" onClick={() => setShowNavbar(false)}>{t("home")}</Link>
            </li>
            <li>
              <Link to="/about" onClick={() => setShowNavbar(false)}>{t("about")}</Link>
            </li>
            <li>
              <Link to="/fleet" onClick={() => setShowNavbar(false)}>{t("fleet")}</Link>
            </li>
            <li>
              <Link to="/contacts" onClick={() => setShowNavbar(false)}>{t("contacts")}</Link>
            </li>
            <li>
              <Link to="/blog" onClick={() => setShowNavbar(false)}>Blog</Link>
            </li>
            <li>
              <FormControl sx={{ minWidth: 120 }}>
                <Select
                  value={i18n.language}
                  onChange={onChangeLang}
                  displayEmpty
                  sx={{
                    backgroundColor: "#F4F4F4",
                    borderColor: "#F4F4F4",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#F4F4F4",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                    },
                    "& .MuiSelect-select": {
                      fontSize: "20px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      color: "#1c2541",
                    },
                    "& .MuiMenuItem-root": {
                      fontSize: "20px",
                      fontFamily: "Poppins, sans-serif",
                      fontWeight: 400,
                      color: "#1c2541",
                    },
                  }}
                  renderValue={(selected) => {
                    const FlagComponent = flagMap[selected] || flagMap["pt"];
                    return (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <FlagComponent className="flag-icon" />
                        {t(
                          LANGUAGES.find((lang) => lang.code === selected)
                            ?.label || "portuguese",
                        )}
                      </div>
                    );
                  }}
                >
                  {LANGUAGES.map(({ code, label }) => {
                    const FlagComponent = flagMap[code];
                    return (
                      <MenuItem key={code} value={code}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <FlagComponent className="flag-icon" />
                          {t(label)}
                        </div>
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
